import { Tooltip, Zoom } from "@mui/material";

import { CustomizedTooltipPopper } from "./styles";
import {
  ICustomizedTooltipPopperProps,
  ICustomizedTooltipProps,
} from "./types";

const CustomizedTooltip: React.FC<ICustomizedTooltipProps> = ({
  children,
  customPosition,
  tooltipAdditionalStyles,
  ...props
}: ICustomizedTooltipProps) => {
  const tooltipPopperProps: ICustomizedTooltipPopperProps = {
    tooltipAdditionalStyles,
  };

  return (
    <Tooltip
      PopperProps={{
        modifiers: [
          {
            name: "offset",
            options: {
              offset: customPosition,
            },
          },
        ],
      }}
      PopperComponent={
        props.componentsProps ? undefined : CustomizedTooltipPopper
      }
      componentsProps={{ popper: tooltipPopperProps }}
      TransitionComponent={Zoom}
      placement="right-start"
      {...props}
    >
      {children}
    </Tooltip>
  );
};

export default CustomizedTooltip;
